import React from "react";
import { useNavigate } from "react-router-dom";
import Table from "../UI/Table";
import StatusBadge from "../UI/StatusBadge";

const EmailEventTable = ({ events }) => {
  const navigate = useNavigate();

  const calculateSuccessRate = (event) => {
    if (!event.total_recipients) return "0.0";
    return (
      (event.total_success / event.total_recipients) * 100
    ).toFixed(1);
  };

  const columns = [
    { header: "Event", accessor: "event_name" },
    { header: "Category", accessor: "email_category" },
    {
      header: "Status",
      render: (row) => <StatusBadge status={row.status} />,
    },
    { header: "Total", accessor: "total_recipients" },
    {
      header: "Success",
      render: (row) => (
        <span className="text-green-600 font-semibold">
          {row.total_success}
        </span>
      ),
    },
    {
      header: "Failed",
      render: (row) => (
        <span className="text-red-600 font-semibold">
          {row.total_failed}
        </span>
      ),
    },
    {
      header: "%",
      render: (row) => `${calculateSuccessRate(row)}%`,
    },
    {
      header: "Time",
      render: (row) =>
        `${(row.execution_time_ms / 1000).toFixed(2)}s`,
    },
   {
      header: "Triggered By",
      render: (row) =>
        `${row.triggered_by}`,
    },
    {
      header: "Created",
      render: (row) =>
        new Date(row.created_at).toLocaleString(),
    },
  ];

  return (
    <Table
      columns={columns}
      data={events}
      onRowClick={(row) =>
        navigate(`/email-events/${row.id}`)
      }
    />
  );
};

export default EmailEventTable;